module.exports = __webpack_public_path__ + "img/help-center.f75d143a.png";